module.exports = __webpack_public_path__ + "static/media/locked-hint.21a75526.svg";